var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#33CBCC;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.4,0.1H106.6C47.2,2.9,0,51.9,0,111.9v58.7h512v-58.7C512,51.9,464.8,2.9,405.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,399.9c0,61.9,50.1,112,112,112h288c61.9,0,112-50.1,112-112v-58.7H0V399.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 154,
    className: "st0",
    width: 512,
    height: 207
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312.7,195.3c-36.9,14.4-71.8,29.6-99.6,46.3c-29.6,17.9-49.2,41.9-49.2,64.7c0,49.2,53.9,82.9,133.9,82.9 c29,0,55.4-3.5,74.7-8.5l2.1,5.3c-14.9,11.1-31.1,22.6-49.2,32.8c-9.4,5.3-26.7,8.5-50.1,8.5C204.1,427.3,144,393.6,144,318 c0-38.4,20.5-70,48.6-94.6c-31.6-22.6-43.9-38.4-43.9-63.9c0-12.6,4.4-29.9,13.2-44.8c13.5-22.3,33.4-34.3,54.5-34.3 c25.8,0,45.1,12.9,63,36.9l-4.7,6.2c-15.2-7-29.9-9.7-45.4-9.7c-32.5,0-58.6,16.4-58.6,28.4c0,13.2,7.6,23.7,25.5,37.2 c10.5,7.6,25.2,15.8,31.1,15.8s11.1-2.9,16.1-5.3c26.4-12.6,52.7-24,79.1-34l1.5,0.9L312.7,195.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/Ar.05ca30ff33ebb6024307fc9d86e38262.svg";
export { ForwardRef as ReactComponent };